/**
 * @desc 使用formData传递数据的接口地址
 */
const formDataUrlList = [
    /**
     * @desc 企业管理员页面接口
     */
    // 发送验证码
    '/mng/account/contacts/sendContactVerifySMS',
    // 验证验证码
    '/mng/account/contacts/checkContactVerifyCode',
    // 提交申请表
    '/mng/account/contacts/updateAdminContact',
    // 修改管理员qq/手机号 原手机号发送验证码
    '/mng/account/contacts/sendVerifySMS',
    // 修改管理员qq/手机号 原手机号校验
    '/mng/account/contacts/checkVerifySMS',
    // 修改管理员
    '/mng/account/contacts/updateContactMobile',
    // 修改管理员邮箱
    '/mng/account/contacts/updateContactEmail',
    // 修改管理员名称
    '/mng/account/contacts/updateContactName',
    // 关闭审核状态提示条
    '/mng/account/contacts/updateContactTips',
     /**
     * @desc 权限角色页面接口
     */
    // 创建权限角色
    '/mng/role/roleCreate',
    // 删除角色
    '/mng/role/delRole',
    // 添加角色
    '/mng/role/addUser',
    // 更新权限角色生效范围
    '/mng/role/updatePermissionMngScope',
    // 更新员工角色
    '/mng/org/changeTerminalPrivilegesDetection',
    '/mng/role/delCol',
    // 获取角色下员工列表
    '/mng/role/kfextListByRoleId',
    // 搜索角色下员工列表
    '/mng/role/queryUserInfo',
    /**
     * @desc 企业资料页面接口
     */
    // 企业资料发送验证码
    '/mng/account/contacts/genExternalPhoneVerifyCode',
    // 企业资料校验验证码
    '/mng/account/contacts/checkCorpPhoneVerifyCode',
    // 企业资料关联企业修改
    '/mng/account/RelatedCorp/Create',
    // 企业资料主企业修改
    '/mng/account/corpInfo/create',
    // 公众号列表刷新状态
    '/mp/accountInfo/getWxMaterial',
];

export default formDataUrlList;
